import { merchantIcons } from '@assets/icons';
import { getMerchantDineSavvyLogoCompact } from '@assets/logos';
import { useLogoutConfirm } from '@hooks/LogoutConfirmProvider';
import { memo, useCallback } from 'react';

const AuthPageHeader = memo(() => {
  const { requestLogout } = useLogoutConfirm();

  const handleLogout = useCallback(() => {
    requestLogout();
  }, [requestLogout]);

  return (
    <header className="flex w-full shrink-0 items-center justify-between border-b border-merchant-border bg-white px-page py-3 desktop:py-4">
      <img
        src={getMerchantDineSavvyLogoCompact()}
        alt="Dine Savvy"
        className="h-7 w-auto shrink-0 md:h-[33px] desktop:h-11"
        width={99}
        height={44}
      />

      <button
        type="button"
        onClick={handleLogout}
        className="flex cursor-pointer items-center gap-1.5 desktop:gap-2 rounded-field border-0 bg-merchant-bg-subtle px-2.5 py-2.5 desktop:px-3 desktop:py-3 opacity-80 outline-none focus:outline-none"
      >
        <img src={merchantIcons.logout} alt="" className="icon-lg shrink-0" aria-hidden="true" />
        <span className="desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-[#dc2626]">
          Logout
        </span>
      </button>
    </header>
  );
});

AuthPageHeader.displayName = 'AuthPageHeader';

export default AuthPageHeader;
